module.exports = __webpack_public_path__ + "static/img/house.08520660.svg";